export default __webpack_public_path__ + "static/kasa_4-ba28b6690af9e2afaffd9742799974b1.png";